import { render, staticRenderFns } from "./SocialPostImageSlider.vue?vue&type=template&id=cdbc9760&"
import script from "./SocialPostImageSlider.vue?vue&type=script&lang=js&"
export * from "./SocialPostImageSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports